import * as API from "../url";
import { accountsInstance } from "../axiosInstance";

const request = {
  get: async (url, params = {}) =>
    (await accountsInstance.get(url, { params })).data,

  post: async (url, body = {}, params) =>
    (await accountsInstance.post(url, body, params ? { params } : {})).data,

  put: async (url, body = {}, params) =>
    (await accountsInstance.put(url, body, params ? { params } : {})).data,

  delete: async (url) => (await accountsInstance.delete(url)).data,
};

// === API Calls ===
export const getUser = () => request.get(API.GET_USER);

export const getAllDepts = (pageSize, pageNumber) =>
  request.get(API.GET_ALL_DEPTS, { pageSize, pageNumber });

export const getDept = (id) => request.get(API.GET_DEPT, { id });

export const addDept = (body) => request.post(API.ADD_DEPT, body);

export const updateDept = (body) => request.post(API.UPDATE_DEPT, body);

export const deleteDept = (query) => request.delete(API.DELETE_DEPT(query));

export const getCountries = (pageSize, pageNumber, isSupported, searchParam) =>
  request.get(API.GET_COUNTRIES, {
    pageSize,
    pageNumber,
    isSupported,
    searchParam,
  });

export const addCountry = (body) => request.post(API.GET_COUNTRIES, body);
export const addCurrency = (body) => request.post(API.GET_CURRENCIES, body);
export const addState = (body) => request.post(API.GET_STATES, body);
export const addLga = (body) => request.post(API.GET_LGAS, body);

export const updateCountry = (body) => request.put(API.GET_COUNTRIES, body);
export const updateCurrency = (body) => request.put("country/currency", body);
export const updateState = (body) => request.put("country/state", body);
export const updateLga = (body) => request.put("country/state-lga", body);

export const getCurrencies = (pageSize, pageNumber, isSupported, searchParam) =>
  request.get(API.GET_CURRENCIES, {
    pageSize,
    pageNumber,
    isSupported,
    searchParam,
  });

export const getStates = (
  countryId,
  pageSize,
  pageNumber,
  isSupported,
  searchParam,
) =>
  request.get(API.GET_STATES, {
    countryId,
    pageSize,
    pageNumber,
    isSupported,
    searchParam,
  });

export const getAccAudits = (pageSize, pageNumber) =>
  request.get(`${API.AUDIT}s`, {
    pageSize,
    pageNumber,
  });

export const getLgas = (
  stateId,
  pageSize,
  pageNumber,
  isSupported,
  searchParam,
) =>
  request.get(API.GET_LGAS, {
    stateId,
    pageSize,
    pageNumber,
    isSupported,
    searchParam,
  });

export const addStaff = (body) => request.post(API.ADD_STAFF, body);
